import React, { useEffect } from 'react';
import { Route, Routes } from 'react-router-dom';
import Login from './pages/auth/Login/Login';
import ProjectRegister from './pages/forms/projectRegister/ProjectRegister';
import GlobalAlert from './components/shared/GlobalAlert/GoblalAlert';
import useGlobalState from './context/GlobalState';
import Footer from './components/footer/Footer';
import StateHandler from './components/StateHandler/StateHandler';
import Unauthorized from './pages/common/Unauthorized';
import LoadingPane from './components/shared/loadingPane/LoadingPane';
import ProjectList from './pages/admin/ProjectList/ProjectsList';
import ProjectDetails from './pages/admin/ProjectDetails/ProjectDetails';
import MySidebar from './components/admin/MySidebar';
import Statistics from './pages/admin/Statistics/Statistics';
import EducationPrograms from './pages/admin/EducationPrograms/EducactionPrograms';
import Periods from "./pages/admin/Periods/Periods";
import AppTitleState from "./context/AppTitleState";
import './styles/ReactModal.css';
import './App.css';
import Home from './pages/home/Home';

function App() {
  const { authorizeUser, isLogged } = useGlobalState();

  const getFooter = () => {
    if (!window.location.pathname.includes('admin')) {
      return (
        <Footer />
      );
    }

    return (<></>);
  }

  const getSideBar = () => {
    if (isLogged) {
      return <MySidebar />;
    }

    return (<></>);
  }

  useEffect(() => {
    authorizeUser();
  }, [authorizeUser]);

  return (
    <div className="App">
      <LoadingPane />
      <GlobalAlert />

      <div className="app-content">
        {getSideBar()}
        <div className='app-screens'>
          <AppTitleState>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/admin/login" element={<Login />} />
              <Route path="/admin/logout" element={<Login />} />
              <Route path="/forms/registro_emprendedores" element={<ProjectRegister />} />

              {/* TODO: Change projects routes for cima-emprendedores */}
              <Route path="/admin/forms/projects" element={isLogged ? <ProjectList /> : <Unauthorized />} />
              <Route path='/admin/forms/projects/:id' element={isLogged ? <ProjectDetails /> : <Unauthorized />} />
              <Route path="/admin/forms/projects/statistics" element={isLogged ? <Statistics /> : <Unauthorized />} />
              <Route path="/admin/education-programs" element={isLogged ? <EducationPrograms/> : <Unauthorized/>}/>
              <Route path="/admin/periods" element={isLogged ? <Periods/> : <Unauthorized/>}/>
              {!isLogged && <Route path='/admin/*' element={<Unauthorized/>}/>}

              <Route path="/server-error" element={<StateHandler title='[500] Error interno del servidor' subTitle='Lo sentimos estamos trabajando para mejorar tu experiencia.' showFcitecLink />} />
              <Route path='*' element={<StateHandler title='[404] Contenido no disponible' subTitle='Lo sentimos estamos trabajando para mejorar tu experiencia.' showFcitecLink links={[{ label: "Registrar Proyecto", link: "/emprendedores/forms/registro_emprendedores" }]} />} />
            </Routes>
          </AppTitleState>
          {getFooter()}
        </div>
      </div>
    </div>
  );
}

export default App;
